export const FAQAccordionFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading for FAQs (e.g. 'Frequently Asked Questions')",
      seo: true,
      key: "faq.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Brief introduction to the FAQ section (15-20 words)",
      seo: false,
      key: "faq.subheading",
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Single Column", value: "single-column" },
      { label: "Two Columns", value: "two-column" },
    ],
    metadata: {
      source: "manual",
    },
  },
  faqs: {
    type: "array",
    label: "FAQs",
    metadata: {
      source: "ai",
      description: "List of frequently asked questions and answers",
      seo: true,
      key: "faq.list",
    },
    getItemSummary: (item: { question: string }) =>
      item.question?.substring(0, 50) || "New Question",
    arrayFields: {
      question: {
        type: "text",
        label: "Question",
        metadata: {
          description: "The question being asked",
        },
      },
      answer: {
        type: "textarea",
        label: "Answer",
        metadata: {
          description: "Detailed answer to the question (50-100 words)",
        },
      },
    },
    defaultItemProps: {
      question: "New Question?",
      answer: "Answer to the question.",
    },
  },
  includeSchema: {
    type: "radio",
    label: "Include FAQ Schema",
    options: [
      { label: "Yes (Recommended)", value: true },
      { label: "No", value: false },
    ],
    metadata: {
      source: "manual",
      description: "Include FAQ JSON-LD schema for SEO",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;
